export interface TickerItem {
  label: string;
  text: string;
}

export interface NavItem {
  label: string;
  href: string;
}

export interface LeadStory {
  kicker: string;
  title: string;
  summary: string;
  meta: string;
  reads: string;
  image: string;
  tags: string[];
}

export interface MiniStory {
  category: string;
  title: string;
  time: string;
}

export interface RankItem {
  rank: number;
  title: string;
  heat: string;
  trend: string;
  tag: string;
}

export interface ListItem {
  time: string;
  title: string;
  summary: string;
  tag: string;
  reads: string;
}

export interface ZoneItem {
  title: string;
  summary: string;
  heat: string;
}

export interface CollectionItem {
  title: string;
  count: string;
  desc: string;
  cover: string;
}

export interface TimelineItem {
  date: string;
  title: string;
  desc: string;
}

export const siteName = "51黑料";

export const navItems: NavItem[] = [
  { label: "今日爆料", href: "#today" },
  { label: "热度榜单", href: "#ranking" },
  { label: "明星黑料", href: "#stars" },
  { label: "网红黑料", href: "#creators" },
  { label: "吃瓜合集", href: "#collections" },
  { label: "事件汇总", href: "#timeline" },
];

export const tickerItems: TickerItem[] = [
  { label: "热", text: "顶流男星深夜同框照流出，相关话题阅读量一夜破 3 亿" },
  { label: "爆", text: "选秀爱豆工作室发长文回应，评论区刷屏求一个说法" },
  { label: "热", text: "头部带货主播直播片段疯传，品牌方连夜下架宣传物料" },
  { label: "新", text: "一线女星早年合影被翻出，粉丝控评反而带火原帖" },
  { label: "爆", text: "音乐节现场意外视频流出，主办方凌晨发布致歉声明" },
  { label: "热", text: "综艺剪辑争议冲上热搜榜首，节目组关闭评论区" },
  { label: "新", text: "百万粉博主遭前团队爆料，双方各执一词证据待核" },
  { label: "热", text: "两部待播剧同日放出预告，网友逐帧对比找出删改痕迹" },
];

export const heroLead: LeadStory = {
  kicker: "今日主瓜 · 封面",
  title: "一图看懂：本周最受关注的三条爆料，究竟哪条是真的？",
  summary:
    "从深夜同框到工作室发声，48 小时内围绕这条爆料的讨论量翻了四倍。我们把目前能公开核对的时间线、双方回应与网友扒出的细节整理在一处，帮你快速分清哪些是实锤、哪些还只是猜测。",
  meta: "51黑料编辑部 · 今日 09:20 更新",
  reads: "阅读 128.6 万 · 讨论 2.4 万",
  image:
    "https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20cover%20art%20with%20abstract%20folded%20paper%20shapes%20in%20deep%20crimson%20and%20warm%20gold%20on%20a%20cream%20background%2C%20bold%20geometric%20collage%2C%20high%20contrast%20graphic%20design%2C%20no%20text%2C%20artistic%20poster%20aesthetic&width=1000&height=1250&seq=gossip-hero-cover-01&orientation=portrait",
  tags: ["今日爆料", "大瓜", "事件梳理"],
};

export const heroMiniStories: MiniStory[] = [
  { category: "明星黑料", title: "工作室回应后 6 小时，当事人账号悄悄改了简介", time: "2 小时前" },
  { category: "网红黑料", title: "前团队成员发长文，列出合作期间的聊天记录", time: "4 小时前" },
  { category: "吃瓜合集", title: "把这周所有大瓜做成一条时间线，三分钟看完", time: "6 小时前" },
];

export const rankItems: RankItem[] = [
  { rank: 1, title: "顶流男星深夜同框照持续发酵", heat: "热度 98.6 万", trend: "↑ 12.4%", tag: "爆" },
  { rank: 2, title: "选秀爱豆工作室长文回应全文梳理", heat: "热度 91.2 万", trend: "↑ 9.8%", tag: "热" },
  { rank: 3, title: "带货主播直播片段被逐帧分析", heat: "热度 84.7 万", trend: "↑ 7.1%", tag: "热" },
  { rank: 4, title: "一线女星早年合影原帖为何突然翻红", heat: "热度 76.3 万", trend: "↑ 5.6%", tag: "新" },
  { rank: 5, title: "音乐节冲突视频多方说法对比", heat: "热度 68.9 万", trend: "↑ 4.2%", tag: "热" },
  { rank: 6, title: "综艺剪辑争议：被删掉的 43 秒到底拍了什么", heat: "热度 61.5 万", trend: "↑ 3.8%", tag: "新" },
  { rank: 7, title: "百万粉博主与前团队各执一词，证据待核实", heat: "热度 55.2 万", trend: "↑ 3.1%", tag: "新" },
  { rank: 8, title: "两部待播剧预告同日释出引发对比热潮", heat: "热度 49.7 万", trend: "↑ 2.6%", tag: "热" },
];

export const latestItems: ListItem[] = [
  {
    time: "09:20",
    title: "今日爆料第一批：凌晨流出的三段视频指向同一场聚会",
    summary: "三段视频拍摄角度不同，但背景的陈设与时间戳能相互对应，我们把可核对的部分标了出来。",
    tag: "今日爆料",
    reads: "12.4 万",
  },
  {
    time: "08:55",
    title: "回应来了：工作室称将保留追究法律责任的权利",
    summary: "声明全文约 600 字，未正面回应核心问题，只强调“网络传言不实”，网友并不买账。",
    tag: "明星黑料",
    reads: "9.8 万",
  },
  {
    time: "08:10",
    title: "品牌方连夜动作：官网宣传位已撤下相关内容",
    summary: "截至发稿，两个合作品牌的官方页面已无法检索到该物料，双方暂未发布联合说明。",
    tag: "大瓜",
    reads: "7.2 万",
  },
  {
    time: "07:40",
    title: "网友扒出旧照：两张相隔五年的合影被指同一场景",
    summary: "有细心网友对比了背景中的招牌与窗帘，认为时间线存在疑点，目前仍属推测。",
    tag: "事件汇总",
    reads: "6.5 万",
  },
  {
    time: "06:30",
    title: "吃瓜合集更新：本周十条大瓜整理成一份懒人包",
    summary: "每条都附上关键时间点与当事方回应，适合通勤路上一次性补完，不遗漏任何大瓜。",
    tag: "吃瓜合集",
    reads: "5.9 万",
  },
  {
    time: "00:15",
    title: "深夜话题：为什么大家第一反应都是“不信再看一眼”",
    summary: "从传播路径看，这条爆料先在小圈子发酵，再被搬运到公共平台，扩散速度远超预期。",
    tag: "今日爆料",
    reads: "4.3 万",
  },
];

export const starZoneItems: ZoneItem[] = [
  { title: "顶流男星同框照：目前能确认的三件事", summary: "拍摄时间、地点与同行人数均有交叉印证，其余仍待核实。", heat: "热度 98.6 万" },
  { title: "工作室长文逐句拆解：哪些回应了，哪些绕开了", summary: "把 600 字声明拆成 7 个要点，逐一标注是否回应核心质疑。", heat: "热度 91.2 万" },
  { title: "女主角方面至今零回应，团队背景被网友翻出", summary: "其经纪公司未发布任何声明，社交账号评论区已被关闭。", heat: "热度 73.4 万" },
  { title: "同剧组演员集体沉默，唯独他发了条意味深长的动态", summary: "一条仅九个字的动态被解读出多种版本，本人并未进一步解释。", heat: "热度 58.1 万" },
  { title: "粉丝后援会连夜改公告，措辞从“相信”变成“等待”", summary: "公告两次修改，时间间隔不到三小时，态度变化被网友截图留存。", heat: "热度 46.7 万" },
];

export const creatorZoneItems: ZoneItem[] = [
  { title: "百万粉博主与前团队互撕：一份聊天记录的两套说法", summary: "双方各晒出截图，关键时间点存在 20 分钟出入。", heat: "热度 88.3 万" },
  { title: "带货主播直播翻车完整版疯传，剪辑争议不断", summary: "网传版本经过多次剪辑，我们找到了最初上传的原片。", heat: "热度 84.7 万" },
  { title: "美食博主人设崩塌？合作商家接连删帖的背后", summary: "至少三家商户下架了合作视频，暂无人公开说明原因。", heat: "热度 62.9 万" },
  { title: "短剧达人被指抄袭分镜，原作者放出对比视频", summary: "两段视频逐帧对比，相似度引发行业内外大量讨论。", heat: "热度 54.6 万" },
  { title: "户外博主安全争议再起，平台已对相关内容限流", summary: "平台回应称“依规处理”，当事人尚未作出正式澄清。", heat: "热度 41.2 万" },
];

export const collectionItems: CollectionItem[] = [
  {
    title: "本周大瓜懒人包",
    count: "收录 12 条",
    desc: "把一周内所有热度较高的爆料按时间排好，附关键回应。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20stacked%20newspapers%20and%20folded%20notes%20in%20crimson%20gold%20and%20cream%20tones%2C%20minimal%20editorial%20collage%20style%2C%20abstract%20geometric%20composition%2C%20soft%20even%20background%2C%20no%20text&width=800&height=600&seq=gossip-collection-01&orientation=landscape",
  },
  {
    title: "明星情感线梳理",
    count: "收录 9 条",
    desc: "按时间顺序还原几段被热议的关系传闻，只呈现公开信息。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20intertwined%20ribbons%20and%20timeline%20dots%20in%20deep%20red%20and%20warm%20mustard%20on%20cream%20paper%2C%20minimal%20editorial%20poster%20aesthetic%2C%20clean%20even%20background%2C%20no%20text&width=800&height=600&seq=gossip-collection-02&orientation=landscape",
  },
  {
    title: "网红翻车年鉴",
    count: "收录 15 条",
    desc: "从直播到短视频，盘点近几年争议较大的博主事件。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20cracked%20screen%20and%20scattered%20documents%20in%20crimson%20and%20amber%20on%20a%20cream%20background%2C%20minimal%20editorial%20collage%20style%2C%20clean%20balanced%20composition%2C%20no%20text&width=800&height=600&seq=gossip-collection-03&orientation=landscape",
  },
  {
    title: "待核实线索库",
    count: "收录 27 条",
    desc: "暂时无法确认的爆料单独归档，标注来源与可信度提示。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20magnifying%20glass%20over%20paper%20clippings%20in%20muted%20terracotta%20and%20gold%20tones%20on%20cream%20surface%2C%20minimal%20editorial%20poster%20style%2C%20clean%20even%20background%2C%20no%20text&width=800&height=600&seq=gossip-collection-04&orientation=landscape",
  },
];

export const timelineItems: TimelineItem[] = [
  { date: "10.06", title: "首条爆料在小范围发酵", desc: "一条匿名投稿出现在垂直社区，仅数十人转发，尚未引起注意。" },
  { date: "10.07", title: "搬运至公共平台，话题开始升温", desc: "多个账号同步搬运，话题词条首次进入热榜，讨论量开始爬升。" },
  { date: "10.08", title: "当事方工作室首次发声", desc: "声明否认核心传言，但未提供进一步证据，评论区迅速失控。" },
  { date: "10.09", title: "品牌方与平台方相继动作", desc: "合作物料陆续下架，相关内容被标注“待核实”，热度达到峰值。" },
  { date: "10.10", title: "编辑部整理时间线，区分实锤与猜测", desc: "今日爆料进入第二天，我们把能核对的细节与存疑部分分开呈现。" },
];

export const hotTopics: string[] = [
  "#顶流同框",
  "#工作室回应全文",
  "#带货翻车直播",
  "#女星旧照",
  "#音乐节冲突",
  "#综艺剪辑争议",
  "#待播剧预告对比",
  "#博主互撕",
  "#吃瓜懒人包",
  "#本周大瓜",
];

export const editorNote = {
  title: "编辑部说明",
  body:
    "本站内容均为公开网络信息的整理与呈现，标注来源与热度仅用于吃瓜参考。涉及具体人物与事件的描述请以官方与当事方最终回应为准，请理性吃瓜、勿传谣。",
};